import React from 'react';
import { APP_NAME } from '../lib/brand';

const BrandLogo = ({ size = 96, radius = 16, className = '' }) => {
  return (
    <img
      src={`${process.env.PUBLIC_URL || ''}/logo.png`}
      alt={APP_NAME}
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        objectFit: 'contain',
        flexShrink: 0,
      }}
    />
  );
};

export default BrandLogo;
